/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



$(document).ready(function () {

$('.ProductForm__AddToCart2').click(function(e){    
  e.preventDefault();
  var ID = $(this).closest('.collection_btn_link').attr("data-pd-id");
  console.log("sdadasdad")
  addItemToCart( ID, 1);    // paste your id product number
  $('.cart_dr').trigger( "click" );

});
function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      $('#CartCount span').text(data.quantity);
      console.log(data.quantity);
      $("#sidebar-cart").removeAttr("aria-hidden");
      $("#sidebar-cart").attr("aria-hidden",'false');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
    }   

  }); 

}

$(".Drawer__Close").on('click', function(){
  $("#sidebar-cart").attr("aria-hidden",'true');
});


 
 $(".tab_button").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".tab_content")
        .slideUp(200);
    } else {

      $(".tab_button").removeClass("active");
      $(this).addClass("active");
      $(".tab_content").slideUp(200);
      $(this)
        .siblings(".tab_content")
        .slideDown(200);
    }
  });
 
$maxHeight = 0;
  $(".ProductItem__Info").each(function(){
    if($(this).height() > $maxHeight) {
      $maxHeight = $(this).height();
    }
  });
  $(".ProductItem__Info").height($maxHeight);
});

// setInterval(function(){ 
// 	console.log("Oooo Yeaaa!");
// $( "#advancedRegForm" ).contents().find( "html" ).css( "background-color", "#BADA55" );
//   console.log($( "#advancedRegForm" ).contents().find( "html" ).css( "background-color", "#BADA55" ));
// }, 2000);//run this thang every 2 seconds

if ($(window).width() > 1007) {
var $carousel = $('.carousel--collection-page').flickity({
    "prevNextButtons": true,
    "pageDots": false,
    "wrapAround": false,
    "contain": true,
    "cellAlign": "center",
    "watchCSS": true,
    "dragThreshold": 8,
    "groupCells": true,
    "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
});
}